/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const ENTERPRISE_GET_VIEW_TIME = 'MFE/MBP-CHECKOUT/ENTERPRISE_GET_VIEW_TIME';
export const ENTERPRISE_DELETE_VIEW_TIME = 'MFE/MBP-CHECKOUT/ENTERPRISE_DELETE_VIEW_TIME';
export const ENTERPRISE_UPDATE_FUNERAL_SERVICE_TIME = 'MFE/MBP-CHECKOUT/ENTERPRISE_UPDATE_FUNERAL_SERVICE_TIME';
